import ReactDOM  from 'react-dom'
import App from './App'


const divRoot=document.querySelector("#redoc");


ReactDOM.render(<App/>,divRoot)